import { PowerSwitchStatus } from 'api/blockchain/rewardProgram';

const getColorScheme = (status: PowerSwitchStatus) => {
  if (status === PowerSwitchStatus.ONLINE) {
    return 'green';
  }
  if (status === PowerSwitchStatus.SHUTDOWN) {
    return 'red';
  }
  if (status === PowerSwitchStatus.NOTSTARTED) {
    return 'orange';
  }
};

export default getColorScheme;
